import React, { FC } from 'react';
import { TableFilterRow } from '@devexpress/dx-react-grid-material-ui';
import { CustomFilterRowProps } from '../../../types';

import styles from '../GovernanceTagsTableController.module.scss';

export const CustomFilterRow: FC<CustomFilterRowProps> = ({ children, tableRow, ...restProps }) => (
  <TableFilterRow.Row {...restProps} tableRow={tableRow} className={styles.filterRow}>
    {children}
  </TableFilterRow.Row>
);
